import React, { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import api from "../../../services/api";
import UpsellTable from "./UpsellTable";
import UpsellFormModal from "./UpsellFormModal";
import { useSnackbarAlert } from "../../../hooks/useSnackbarAlert";

const AdminUpsellPage = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const snackbar = useSnackbarAlert();

  useEffect(() => {
    fetchItems();
  }, []);

  const fetchItems = async () => {
    const response = await api.get("/upsell-items");
    setItems(response.data);
  };

  const handleSave = async (data) => {
    try {
      if (editing) {
        await api.put(`/upsell-items/${editing._id}`, data);
      } else {
        await api.post("/upsell-items", data);
      }

      snackbar.success("Upsell item saved!");
      fetchItems();
    } catch (err) {
      console.error("Failed to save item", err);
      snackbar.error("Something went wrong while saving.");
    } finally {
      setOpen(false);
      setEditing(null);
    }
  };

  const handleToggleVisible = async (item) => {
    await api.patch(`/upsell-items/${item._id}`, {
      visible: !item.visible,
    });
    fetchItems();
  };

  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <Typography variant="h5" fontWeight="bold">
          Upsell Items
        </Typography>
        <Button variant="contained" onClick={() => setOpen(true)}>
          Add New
        </Button>
      </Box>

      <UpsellTable
        items={items}
        onEdit={(item) => {
          setEditing(item);
          setOpen(true);
        }}
        onToggleVisible={handleToggleVisible}
      />

      <UpsellFormModal
        open={open}
        onClose={() => {
          setOpen(false);
          setEditing(null);
        }}
        onSave={handleSave}
        initialData={editing}
      />
    </Box>
  );
};

export default AdminUpsellPage;
